export type Nacionalidade = 'Brasil' | 'Internacional'

export class TelefoneUtils {
  static formatarTelefoneBrasil(digits: string): string {
    if (!digits) return ''
    const limitedDigits = digits.slice(0, 11)
    let formatted = '+55 (' + limitedDigits.slice(0, 2)
    if (limitedDigits.length <= 2) return formatted + ')'
    formatted += ') '
    const rest = limitedDigits.slice(2, 11)
    if (rest.length <= 4) return formatted + rest
    const nine = rest.length === 9
    const first = nine ? rest.slice(0, 5) : rest.slice(0, 4)
    const last = rest.slice(first.length)
    return `${formatted}${first}-${last}`
  }

  static formatarTelefone(numero: string, nacionalidade: Nacionalidade): string {
    if (nacionalidade !== 'Brasil') return numero
    return this.formatarTelefoneBrasil(numero)
  }
}
